import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import SingleCard from "../card/singleCard";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { getAllArts } from "../../redux/arts/arts.action";

const useStyles = makeStyles((theme) => ({
  gallery: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
    gridGap: theme.spacing(1),
    padding: "15px 0",
    justifyItems: "center",
  },
}));

const NFTGallery = ({ title, tier }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isNotMobile = useMediaQuery("(min-width:900px)");
  const [filteredResults, setFilteredResults] = useState([]);
  const dispatch = useDispatch();
  const classes = useStyles();
  let numberOfTokens = 3;
  if (isMobile) {
    numberOfTokens = 1;
  }
  useEffect(() => {
    dispatch(getAllArts({ page: 1, tier: tier })).then((data) => {
      setFilteredResults(data?.payload?.data);
    });
  }, [dispatch, tier]);

  return (
    <>
      {filteredResults && filteredResults?.length > 0 ? (
        <Box py={4}>
          <Box textAlign={"center"}>
            <Typography
              sx={{
                color: "white",
                fontSize: { lg: "36px", md: "32px", sm: "32px" },
                fontWeight: 700,
              }}
            >
              {title}
            </Typography>
          </Box>
          <div className={classes.gallery}>
            {filteredResults &&
              filteredResults
                .slice(0, numberOfTokens)
                .map((items) => <SingleCard key={items.id} {...items} />)}
          </div>
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Button
              sx={{ background: "#1976d2", padding: "10px 40px !important" }}
              variant="contained"
              component={Link}
              to={`/tier/${tier}`}
            >
              View More
            </Button>
          </Box>
        </Box>
      ) : (
        <Box></Box>
      )}
    </>
  );
};

export default NFTGallery;
